import _ from 'lodash';
//
// helpers
//

export function urlParamVal(value, extra?) {
    if (typeof value === 'boolean') {
        return value;
    } else if (extra) {
        return { value, extra };
    } else {
        return { value };
    }
}

export function urlParamValEq(a, b) {
    if (typeof a === 'boolean') {
        return a === b;
    } else if (Array.isArray(a)) {
        return a.length === b.length && a.every((v, i) => urlParamValEq(v, b[i]));
    } else {
        return a.value === b.value && a.extra === b.extra;
    }
}

export function everyArrayParamObj(arrayOfParams, validValFn) {
    return (
        Array.isArray(arrayOfParams) &&
        arrayOfParams.every((paramObj) => validValFn(paramObj.value))
    );
}

export function isValidUrl(string) {
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
}

function parseUrlValueString(valueStr) {
    valueStr = decodeURIComponent(valueStr);
    if (valueStr[0] === '(') {
        if (valueStr === '()') {
            return [];
        } else {
            const match = valueStr.match(/\((.*?)\)/);
            return match && match.length ? match[1].split(',').map(parseUrlValueString) : [];
        }
    } else if (valueStr.includes(':')) {
        const splitValues = valueStr.split(':');
        return {
            value: splitValues[0],
            // Adding this limit here for the odd case where we are splitting a datetime
            // string. This will split the datetime string into 2 halves in this case which
            // we can easily put back together.
            // TODO: Handle this edge base better
            extra: _.tail(splitValues).join(':'),
        };
    } else if (valueStr.includes(',')) {
        return valueStr.split(',').map(parseUrlValueString);
    } else if (valueStr && !isNaN(valueStr)) {
        return { value: parseFloat(valueStr) };
    } else {
        return { value: valueStr };
    }
}

function parseSearchString(searchStr) {
    return searchStr.includes('?')
        ? searchStr
              .split('?')[1]
              .split('&')
              .reduce((params, part) => {
                  const [key, value] = part.split('=');
                  const parsedKey = key[0] === '!' ? key.slice(1) : key;
                  return Object.assign(params, {
                      [parsedKey]: value ? parseUrlValueString(value) : key[0] !== '!',
                  });
              }, {})
        : {};
}

function buildUrlValueString(value) {
    if (Array.isArray(value)) {
        return `(${value.map(buildUrlValueString).join()})`;
    } else if (value.extra) {
        return `${value.value}:${value.extra}`;
    } else {
        return `${value.value}`;
    }
}

export function buildSearchString(params) {
    return Object.keys(params)
        .reduce((paramStr, key) => {
            const value = params[key];
            if (value === true) {
                return paramStr.concat(`${key}&`);
            } else if (value === false) {
                return paramStr.concat(`!${key}&`);
            } else {
                return paramStr.concat(`${key}=${buildUrlValueString(value)}&`);
            }
        }, '?')
        .slice(0, -1);
}

//
// window object manipulation
//

export function currentUrlParams($window) {
    return parseSearchString($window.location.search);
}

/**
 * This function will preserve the path name, only
 * changing the searchStr
 * @param $window
 * @param searchStr
 */
export function pushHistoryState($window, searchStr) {
    // Don't double push the same search string otherwise we need to hit back twice
    // to pop the state
    if (searchStr !== window.location.search) {
        $window.history.pushState({}, '', `${$window.location.pathname}${searchStr}`);
    }
}

/**
 * This function will preserve the path name, only
 * changing the searchStr
 * @param $window
 * @param searchStr
 */
export function replaceHistoryState($window, searchStr) {
    $window.history.replaceState({}, '', `${$window.location.pathname}${searchStr}`);
}
